export default "__VITE_PUBLIC_ASSET__368b14c5__"